import { render, staticRenderFns } from "./video.vue?vue&type=template&id=3d7fbdad&scoped=true"
import script from "./video.vue?vue&type=script&lang=js"
export * from "./video.vue?vue&type=script&lang=js"
import style0 from "./video.vue?vue&type=style&index=0&id=3d7fbdad&prod&lang=scss"
import style1 from "./video.vue?vue&type=style&index=1&id=3d7fbdad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d7fbdad",
  null
  
)

export default component.exports